import SignIn from '@/views/auth/SignIn';

export default SignIn;
